import { Message } from '../../types/chat';
import { openAIService } from '../ai/openAIService';
import { messageService } from './MessageService';
import { detectLanguage } from '../../utils/language';
import { delay } from '../../utils/time';
import { shouldAskFollowUp, getFollowUpQuestion, findRelevantInfo } from '../../utils/chatUtils';
import { database } from '../../data/database';

export class ChatService {
  private typingDelay = 3000; // Increased from 1 second to 3 seconds
  private shortDelay = 500; // 0.5 second delay between messages

  async sendMessage(content: string): Promise<Message> {
    try {
      // Initial typing delay
      await delay(this.typingDelay);
      
      const language = detectLanguage(content);
      const info = await findRelevantInfo(content, database);
      const shouldFollowUp = shouldAskFollowUp(content, info);
      
      // Generate initial response
      const response = await openAIService.generateResponse(content, {
        shouldFollowUp,
        relevantInfo: info
      });

      let formattedContent = response.content;

      // Add follow-up question if needed
      if (shouldFollowUp) {
        await delay(this.shortDelay);
        formattedContent += '\n\n' + getFollowUpQuestion(content, language);
      }

      // Removed the follow-up offer code that was here

      return messageService.createMessage({
        content: formattedContent,
        sender: 'assistant'
      });
    } catch (error) {
      return this.handleError(content);
    }
  }

  private handleError(content: string): Message {
    const language = detectLanguage(content);
    return messageService.createMessage({
      content: language === 'nl' 
        ? 'Sorry, er is een fout opgetreden. Probeer het opnieuw.'
        : 'Sorry, an error occurred. Please try again.',
      sender: 'assistant'
    });
  }
}

export const chatService = new ChatService();